"use client";

import * as React from "react";
import { Plus } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuShortcut,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu";
import { Button } from "../ui/button";
import { ResponsiveDrawerForm } from "../ResponsiveDrawerForm";
// import AddTrusts from "../../pages/Trusts/AddTrusts";
import { useTrust } from "../../lib/context/TrustContext";
import { useOrganization } from "../../lib/context/OrganisationContext";
import AddEditTrust from "../../pages/Trust/AddEditTrust";
import { useLocation, useNavigate } from "react-router-dom";
import { AnimatedTooltip } from "../AnimatedTooltip";

export function TrustSwitcher({ mobileMenu }) {
  const { fetchTrustList, trustList, trustId } = useTrust();
  const [addTrustModal, setAddTrustModal] = React.useState(false);

  const [activeTrust, setActiveTrust] = React.useState(
    trustId ? trustList?.find((item) => item.value === trustId) : trustList?.[0]
  );

  const { organizationData } = useOrganization();

  React.useEffect(() => {
    if (
      organizationData?.organizationId &&
      organizationData?.organizationId !== undefined
    ) {
      fetchTrustList(organizationData?.organizationId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [organizationData?.organizationId]);

  React.useEffect(() => {
    setActiveTrust(
      trustId
        ? trustList?.find((item) => item.value === trustId)
        : trustList?.[0]
    );
  }, [trustId, trustList]);

  const toggleAddTrustModal = () => {
    setAddTrustModal(!addTrustModal);
  };

  const navigate = useNavigate();
  const location = useLocation();

  const handleTrustClick = (newTrustId) => {
    const currentPath = location.pathname;
    const currentQuery = location.search;

    // Replace current ID in the path with new ID
    const updatedPath = currentPath.replace(
      /\/trusts\/[^/]+/,
      `/trusts/${newTrustId}`
    );

    // Navigate to updated URL
    navigate(`${updatedPath}${currentQuery}`);
  };

  return (
    <>
      <DropdownMenu>
        <AnimatedTooltip title={"Trust"} bottomAlign={true} leftAlign={true}>
          <DropdownMenuTrigger asChild>
            <Button
              size="md"
              className={`px-2 py-1.5 bg-webSecondary ${
                mobileMenu
                  ? "min-w-[246px] max-w-[246px]"
                  : "min-w-[160px] max-w-[160px]"
              }`}
            >
              <div className="flex size-6 items-center justify-center rounded-sm border bg-webPrimary">
                <div className="size-4 flex items-center justify-center">
                  {activeTrust?.label?.charAt(0)}
                </div>
              </div>
              <div className="flex-1 ml-2 text-left text-sm leading-tight">
                <div className="max-w-[110px] truncate font-semibold">
                  {activeTrust?.business_name
                  ? activeTrust?.business_name
                  : activeTrust?.first_name
                  ? activeTrust?.first_name + " " + activeTrust?.last_name
                  : activeTrust?.last_name}
                </div>
              </div>
              {/* <ChevronsUpDown className="ml-1 size-5" /> */}
            </Button>
          </DropdownMenuTrigger>
        </AnimatedTooltip>
        <DropdownMenuContent
          className="w-[--radix-dropdown-menu-trigger-width] min-w-56 rounded-lg"
          align="start"
          side={"bottom"}
          sideOffset={4}
        >
          <DropdownMenuLabel className="text-xs text-muted-foreground mb-1">
            Trusts
          </DropdownMenuLabel>
          <DropdownMenuSeparator />
          {trustList?.length > 0 &&
            trustList?.map((trust, index) => (
              <DropdownMenuItem
                key={index}
                onClick={() => {
                  setActiveTrust(trust);
                  handleTrustClick(trust?.value);
                }}
                className={`gap-2 p-2 mb-1 ${
                  trust?.value === trustId ? "bg-accent" : ""
                }`}
              >
                <div className="flex size-6 items-center justify-center rounded-sm border bg-webPrimary text-white">
                  <div className="size-4 shrink-0 flex items-center justify-center">
                    {trust?.label?.charAt(0)}
                  </div>
                </div>
                {trust?.business_name
                  ? trust?.business_name
                  : trust?.first_name
                  ? trust?.first_name + " " + trust?.last_name
                  : trust?.last_name}
                <DropdownMenuShortcut>⌘{index + 1}</DropdownMenuShortcut>
              </DropdownMenuItem>
            ))}
          <DropdownMenuSeparator />
          <DropdownMenuItem
            className="gap-2 p-2"
            onClick={() => {
              toggleAddTrustModal();
            }}
          >
            <div className="flex size-6 items-center justify-center rounded-md border bg-background">
              <Plus className="size-4" />
            </div>
            <div className="font-medium text-muted-foreground">Add Trust</div>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>

      <ResponsiveDrawerForm
        description={""}
        title={"Add Trust"}
        handleOpen={() => {}}
        handleClose={() => {
          setAddTrustModal(false);
        }}
        buttonText={""}
        className={""}
        open={addTrustModal}
        buttonClassName={""}
        setOpen={setAddTrustModal}
      >
        <AddEditTrust
          toggleShowAddEditTrust={toggleAddTrustModal}
          fetchTrusts={fetchTrustList}
          orgId={organizationData?.organizationId}
        />
      </ResponsiveDrawerForm>
    </>
  );
}
